import {
  REPORT_EXPORT_ORDERS,
  REPORT_EXPORT_SHIPPED_ORDERS,
  REPORT_EXPORT_PRODUCTS_INVENTORY,
  REPORT_EXPORT_PRODUCTS_NO_INVENTORY,
  REPORT_EXPORT_PRODUCTS_FULFILLMENT_SPEED,
  REPORT_EXPORT_PRODUCTS_SALES_CHANNELS,
  REPORT_EXPORT_PRODUCTS_SUPPLIERS,
  REPORT_EXPORT_INVENTORY_SNAPSHOT,
  REPORT_EXPORT_RMA_SUMMARY,
  REPORT_EXPORT_RMA_DETAIL,
  REPORT_EXPORT_SKU_SALES,
  REPORT_EXPORT_DELIVERY_STATUS_DETAIL,
  REPORT_EXPORT_DELIVERY_STATUS_SUMMARY,
  REPORT_EXPORT_FULFILLMENT_SPEED,
  REPORT_EXPORT_LOW_INVENTORY,
  REPORT_LOW_INVENTORY_REPORT,
  REPORT_EXPORT_PURCHASE_ORDER_SUMMARY,
  REPORT_EXPORT_PURCHASE_ORDER_DETAIL,
  REPORT_EXPORT_GOODS_RECEIPT,
  REPORT_EXPORT_BOM_INVENTORY,
  REPORT_EXPORT_BOM_STRUCTURE,
  REPORT_EXPORT_KIT_INVENTORY,
  REPORT_EXPORT_KIT_STRUCTURE,
  REPORT_EXPORT_INVENTORY_EVENTS,
  REPORT_EXPORT_MO_DETAIL,
  REPORT_EXPORT_MO_SUMMARY,
} from '../../../common/constants/Reports.js'
import ExportBOMInventoryForm, {
  exportBOMInventoryErrorsSelector,
  exportBOMInventoryPayloadSelector,
  setupExportBOMInventoryForm,
} from './ExportBOMInventory.js'
import ExportBOMStructureForm, {
  exportBOMStructureErrorsSelector,
  exportBOMStructurePayloadSelector,
  setupExportBOMStructureForm,
} from './ExportBOMStructure.js'
import ExportDeliveryStatusForm, {
  exportDeliveryStatusErrorsSelector,
  exportDeliveryStatusPayloadSelector,
  setupExportDeliveryStatusForm,
} from './ExportDeliveryStatus.js'
import ExportKitInventoryForm, {
  exportKitInventoryErrorsSelector,
  exportKitInventoryPayloadSelector,
  setupExportKitInventoryForm,
} from './ExportKitInventory.js'
import ExportKitStructureForm, {
  exportKitStructureErrorsSelector,
  exportKitStructurePayloadSelector,
  setupExportKitStructureForm,
} from './ExportKitStructure.js'
import ExportOrdersForm, {
  exportOrdersErrorsSelector,
  ExportOrdersParamsSummary,
  exportOrdersPayloadSelector,
  setupExportOrdersForm,
} from './ExportOrders.js'
import ExportPOGoodsReceiptsForm, {
  setupExportPOGoodsReceiptsForm,
  exportPOGoodsReceiptsErrorsSelector,
  exportPOGoodsReceiptsPayloadSelector,
} from './ExportPOGoodsReceipts.js'
import ExportPOsForm, {
  ExportPOParamsSummary,
  exportPOsErrorsSelector,
  exportPOsPayloadSelector,
  setupExportPOsForm,
} from './ExportPOs.js'
import ExportProductsForm, {
  setupExportProductsForm,
  exportProductsErrorsSelector,
  exportProductsPayloadSelector,
} from './ExportProducts.js'
import ExportProductsFulfillmentSpeedForm, {
  exportProductsFulfillmentSpeedErrorsSelector,
  exportProductsFulfillmentSpeedPayloadSelector,
  setupExportProductsFulfillmentSpeedForm,
} from './ExportProductsFulfillmentSpeed.js'
import ExportProductsSalesChannelsForm, {
  exportProductsSalesChannelsErrorsSelector,
  exportProductsSalesChannelsPayloadSelector,
  setupExportProductsSalesChannelsForm,
} from './ExportProductsSalesChannels.js'
import ExportRMAsForm, {
  exportRMAsErrorsSelector,
  exportRMAsPayloadSelector,
  setupExportRMAsForm,
} from './ExportRMAs.js'
import ExportSKUSalesForm, {
  exportSKUSalesErrorsSelector,
  exportSKUSalesPayloadSelector,
  setupExportSKUSalesForm,
} from './ExportSKUSales.js'
import ExportFulfillmentSpeedForm, {
  exportFulfillmentSpeedErrorsSelector,
  exportFulfillmentSpeedPayloadSelector,
  setupExportFulfillmentSpeedForm,
} from './ExportFulfillmentSpeed.js'
import ExportLowInventoryForm, {
  exportLowInventoryErrorsSelector,
  exportLowInventoryPayloadSelector,
  setupExportLowInventoryForm,
} from './ExportLowInventory.js'
import ExportInventoryEventsForm, {
  exportInventoryEventsErrorsSelector,
  exportInventoryEventsPayloadSelector,
  setupExportInventoryEventsForm,
} from './ExportInventoryEvents.js'
import ExportMOsForm, {
  setupExportMOsForm,
  exportMOsErrorsSelector,
  exportMOsPayloadSelector,
} from './ExportMOs.js'
import ExportInventorySnapshotForm, {
  exportInventorySnapshotErrorsSelector,
  exportInventorySnapshotPayloadSelector,
  setupExportInventorySnapshotForm,
} from './ExportInventorySnapshot.js'
import {ExportProductsParamsSummary} from './ProductFilters.js'

export default {
  [REPORT_EXPORT_BOM_INVENTORY]: {
    type: REPORT_EXPORT_BOM_INVENTORY,
    Component: ExportBOMInventoryForm,
    setupForm: setupExportBOMInventoryForm,
    errorsSelector: exportBOMInventoryErrorsSelector,
    payloadSelector: exportBOMInventoryPayloadSelector,
  },
  [REPORT_EXPORT_BOM_STRUCTURE]: {
    type: REPORT_EXPORT_BOM_STRUCTURE,
    Component: ExportBOMStructureForm,
    setupForm: setupExportBOMStructureForm,
    errorsSelector: exportBOMStructureErrorsSelector,
    payloadSelector: exportBOMStructurePayloadSelector,
  },
  [REPORT_EXPORT_KIT_INVENTORY]: {
    type: REPORT_EXPORT_KIT_INVENTORY,
    Component: ExportKitInventoryForm,
    setupForm: setupExportKitInventoryForm,
    errorsSelector: exportKitInventoryErrorsSelector,
    payloadSelector: exportKitInventoryPayloadSelector,
  },
  [REPORT_EXPORT_KIT_STRUCTURE]: {
    type: REPORT_EXPORT_KIT_STRUCTURE,
    Component: ExportKitStructureForm,
    setupForm: setupExportKitStructureForm,
    errorsSelector: exportKitStructureErrorsSelector,
    payloadSelector: exportKitStructurePayloadSelector,
  },
  [REPORT_EXPORT_ORDERS]: {
    type: REPORT_EXPORT_ORDERS,
    Component: ExportOrdersForm,
    setupForm: setupExportOrdersForm,
    errorsSelector: exportOrdersErrorsSelector,
    payloadSelector: exportOrdersPayloadSelector,
    ParamsSummary: ExportOrdersParamsSummary,
  },
  [REPORT_EXPORT_SHIPPED_ORDERS]: {
    type: REPORT_EXPORT_SHIPPED_ORDERS,
    Component: ExportOrdersForm,
    setupForm: setupExportOrdersForm,
    errorsSelector: exportOrdersErrorsSelector,
    payloadSelector: exportOrdersPayloadSelector,
    ParamsSummary: ExportOrdersParamsSummary,
  },
  [REPORT_EXPORT_PURCHASE_ORDER_DETAIL]: {
    type: REPORT_EXPORT_PURCHASE_ORDER_DETAIL,
    Component: ExportPOsForm,
    setupForm: setupExportPOsForm,
    errorsSelector: exportPOsErrorsSelector,
    payloadSelector: exportPOsPayloadSelector,
    ParamsSummary: ExportPOParamsSummary,
  },
  [REPORT_EXPORT_PURCHASE_ORDER_SUMMARY]: {
    type: REPORT_EXPORT_PURCHASE_ORDER_SUMMARY,
    Component: ExportPOsForm,
    setupForm: setupExportPOsForm,
    errorsSelector: exportPOsErrorsSelector,
    payloadSelector: exportPOsPayloadSelector,
    ParamsSummary: ExportPOParamsSummary,
  },
  [REPORT_EXPORT_GOODS_RECEIPT]: {
    type: REPORT_EXPORT_GOODS_RECEIPT,
    Component: ExportPOGoodsReceiptsForm,
    setupForm: setupExportPOGoodsReceiptsForm,
    errorsSelector: exportPOGoodsReceiptsErrorsSelector,
    payloadSelector: exportPOGoodsReceiptsPayloadSelector,
  },
  [REPORT_EXPORT_PRODUCTS_INVENTORY]: {
    type: REPORT_EXPORT_PRODUCTS_INVENTORY,
    Component: ExportProductsForm,
    setupForm: setupExportProductsForm,
    errorsSelector: exportProductsErrorsSelector,
    payloadSelector: exportProductsPayloadSelector,
    ParamsSummary: ExportProductsParamsSummary,
  },
  [REPORT_EXPORT_PRODUCTS_NO_INVENTORY]: {
    type: REPORT_EXPORT_PRODUCTS_NO_INVENTORY,
    Component: ExportProductsForm,
    setupForm: setupExportProductsForm,
    errorsSelector: exportProductsErrorsSelector,
    payloadSelector: exportProductsPayloadSelector,
    ParamsSummary: ExportProductsParamsSummary,
  },
  [REPORT_EXPORT_PRODUCTS_SALES_CHANNELS]: {
    type: REPORT_EXPORT_PRODUCTS_SALES_CHANNELS,
    Component: ExportProductsSalesChannelsForm,
    setupForm: setupExportProductsSalesChannelsForm,
    errorsSelector: exportProductsSalesChannelsErrorsSelector,
    payloadSelector: exportProductsSalesChannelsPayloadSelector,
  },
  [REPORT_EXPORT_PRODUCTS_SUPPLIERS]: {
    type: REPORT_EXPORT_PRODUCTS_SUPPLIERS,
    Component: ExportProductsForm,
    setupForm: setupExportProductsForm,
    errorsSelector: exportProductsErrorsSelector,
    payloadSelector: exportProductsPayloadSelector,
    ParamsSummary: ExportProductsParamsSummary,
  },
  [REPORT_EXPORT_INVENTORY_SNAPSHOT]: {
    type: REPORT_EXPORT_INVENTORY_SNAPSHOT,
    Component: ExportInventorySnapshotForm,
    setupForm: setupExportInventorySnapshotForm,
    errorsSelector: exportInventorySnapshotErrorsSelector,
    payloadSelector: exportInventorySnapshotPayloadSelector,
  },
  [REPORT_EXPORT_RMA_SUMMARY]: {
    type: REPORT_EXPORT_RMA_SUMMARY,
    Component: ExportRMAsForm,
    setupForm: setupExportRMAsForm,
    errorsSelector: exportRMAsErrorsSelector,
    payloadSelector: exportRMAsPayloadSelector,
  },
  [REPORT_EXPORT_RMA_DETAIL]: {
    type: REPORT_EXPORT_RMA_DETAIL,
    Component: ExportRMAsForm,
    setupForm: setupExportRMAsForm,
    errorsSelector: exportRMAsErrorsSelector,
    payloadSelector: exportRMAsPayloadSelector,
  },
  [REPORT_EXPORT_SKU_SALES]: {
    type: REPORT_EXPORT_SKU_SALES,
    Component: ExportSKUSalesForm,
    setupForm: setupExportSKUSalesForm,
    errorsSelector: exportSKUSalesErrorsSelector,
    payloadSelector: exportSKUSalesPayloadSelector,
  },
  [REPORT_EXPORT_DELIVERY_STATUS_DETAIL]: {
    type: REPORT_EXPORT_DELIVERY_STATUS_DETAIL,
    Component: ExportDeliveryStatusForm,
    setupForm: setupExportDeliveryStatusForm,
    errorsSelector: exportDeliveryStatusErrorsSelector,
    payloadSelector: exportDeliveryStatusPayloadSelector,
  },
  [REPORT_EXPORT_DELIVERY_STATUS_SUMMARY]: {
    type: REPORT_EXPORT_DELIVERY_STATUS_SUMMARY,
    Component: ExportDeliveryStatusForm,
    setupForm: setupExportDeliveryStatusForm,
    errorsSelector: exportDeliveryStatusErrorsSelector,
    payloadSelector: exportDeliveryStatusPayloadSelector,
  },
  [REPORT_EXPORT_PRODUCTS_FULFILLMENT_SPEED]: {
    type: REPORT_EXPORT_PRODUCTS_FULFILLMENT_SPEED,
    Component: ExportProductsFulfillmentSpeedForm,
    setupForm: setupExportProductsFulfillmentSpeedForm,
    errorsSelector: exportProductsFulfillmentSpeedErrorsSelector,
    payloadSelector: exportProductsFulfillmentSpeedPayloadSelector,
  },
  [REPORT_EXPORT_FULFILLMENT_SPEED]: {
    type: REPORT_EXPORT_FULFILLMENT_SPEED,
    Component: ExportFulfillmentSpeedForm,
    setupForm: setupExportFulfillmentSpeedForm,
    errorsSelector: exportFulfillmentSpeedErrorsSelector,
    payloadSelector: exportFulfillmentSpeedPayloadSelector,
  },
  [REPORT_EXPORT_LOW_INVENTORY]: {
    type: REPORT_EXPORT_LOW_INVENTORY,
    Component: ExportLowInventoryForm,
    setupForm: setupExportLowInventoryForm,
    errorsSelector: exportLowInventoryErrorsSelector,
    payloadSelector: exportLowInventoryPayloadSelector,
  },
  [REPORT_LOW_INVENTORY_REPORT]: {
    type: REPORT_LOW_INVENTORY_REPORT,
    Component: ExportLowInventoryForm,
    setupForm: setupExportLowInventoryForm,
    errorsSelector: exportLowInventoryErrorsSelector,
    payloadSelector: exportLowInventoryPayloadSelector,
  },
  [REPORT_EXPORT_INVENTORY_EVENTS]: {
    type: REPORT_EXPORT_INVENTORY_EVENTS,
    Component: ExportInventoryEventsForm,
    setupForm: setupExportInventoryEventsForm,
    errorsSelector: exportInventoryEventsErrorsSelector,
    payloadSelector: exportInventoryEventsPayloadSelector,
  },
  [REPORT_EXPORT_MO_DETAIL]: {
    type: REPORT_EXPORT_MO_DETAIL,
    Component: ExportMOsForm,
    setupForm: setupExportMOsForm,
    errorsSelector: exportMOsErrorsSelector,
    payloadSelector: exportMOsPayloadSelector,
  },
  [REPORT_EXPORT_MO_SUMMARY]: {
    type: REPORT_EXPORT_MO_SUMMARY,
    Component: ExportMOsForm,
    setupForm: setupExportMOsForm,
    errorsSelector: exportMOsErrorsSelector,
    payloadSelector: exportMOsPayloadSelector,
  },
}
